export default "__VITE_ASSET__Dq71ZzNJ__"